export class AppConstants {
    static InsuranceMailType = 'insurance'
    static TaskMailType = 'task'
}